export const typeChangePassword= {
	RESET_PASSWORT: '',
	EMAIL_CONFIRMATION: '1',
}
